import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useLang } from "../lib/lang";
import { useAuth } from "../lib/auth";

export default function Header() {
  const { lang, setLang, t } = useLang();
  const { user } = useAuth();
  const loc = useLocation();
  const isDark = loc.pathname.startsWith("/admin");

  return (
    <header className={`app-header${isDark ? " is-dark" : ""}`} data-testid="app-header">
      <nav className="app-nav wrap">
        <Link
          to="/"
          className="brand-mark brand-mark--logo"
          data-testid="brand-logo"
          onClick={() => {
            if (loc.pathname === "/" || loc.pathname === "/es") {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }
          }}
          aria-label="Brand and Behavior — home"
        >
          <img src="/logo-wordmark.png" alt="Brand and Behavior" />
        </Link>
        <div className="nav-right">
          {user ? (
            <NavLink to={user.role === "admin" ? "/admin" : "/dashboard"} className="nav-link" data-testid="nav-dashboard">
              {user.role === "admin" ? "Admin" : t("Dashboard", "Panel")}
            </NavLink>
          ) : (
            <NavLink to="/login" className="nav-link" data-testid="nav-signin">{t("Sign in", "Iniciar sesión")}</NavLink>
          )}
          <div className="lang">
            <button type="button" className={lang === "en" ? "active" : ""} onClick={() => setLang("en")} data-testid="lang-en">EN</button>
            <span>/</span>
            <button type="button" className={lang === "es" ? "active" : ""} onClick={() => setLang("es")} data-testid="lang-es">ES</button>
          </div>
          <Link to="/services" className="button button-accent" data-testid="nav-start">{t("Start a project", "Iniciar proyecto")}</Link>
        </div>
      </nav>
    </header>
  );
}
